import * as React from 'react';

import { Paper, Typography, LinearProgress } from '@material-ui/core';

import { ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList, Legend } from 'recharts';
import { NumberLessBRL } from '../../../../services';

// tslint:disable-next-line:no-empty-interface
export interface IPublisherSkuSoldProps {
    data:any,
    loading:boolean,
    changeMonthSkuSoldReference(month:number) : void
}

// tslint:disable-next-line:no-empty-interface
export interface IPublisherSkuSoldState {
    customFilter: {
        isChart: boolean
    },
}

export interface IPublisherSkuSoldDataChart {
    dateLabel?: string;
    month: number;
    qtdMonth: number;
    qtdMonthLabel: string;
    qtdTotal: number;
    qtdTotalLabel?: string;
}



// statless component
const PublisherSkuSoldDataChart = ({ data, handleClick }: { data: IPublisherSkuSoldDataChart[], handleClick(data: any, index:number): void }) => (
    <ResponsiveContainer width="100%" height={300}>
        <ComposedChart data={data} margin={{ top: 30, right: 20, left: 0, bottom: 0 }}>
            <CartesianGrid vertical={false} horizontal={false} />
            <XAxis dataKey="dateLabel" />
            <YAxis yAxisId="center" />
            <Tooltip content={<PublisherSkuSoldTooltipData />} />
            <Legend />
            <Bar yAxisId="center" name="Total de Títulos Cadastrados" dataKey="qtdTotal" 
                fill="#323232" isAnimationActive={false} onClick={handleClick}>
                <LabelList dataKey="qtdTotalLabel" position="center" angle={90} className="recharts-label-custom" />
            </Bar>
            <Bar yAxisId="center" name="Títulos Vendidos" dataKey="qtdMonth" 
                fill="#FF6A14" isAnimationActive={false} onClick={handleClick}>
                <LabelList dataKey="qtdMonthLabel" position="center" angle={90} className="recharts-label-custom" />
            </Bar>
        </ComposedChart>
    </ResponsiveContainer>
);

// statless component
const PublisherSkuSoldTooltipData = (props: any) => {

    let content;

    props.payload !== null &&  props.payload !== 0 &&  props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

    return (<div className="tooltip-box">
        <table>
            <tbody>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Mês:</td><td className="tooltip-content">{content && content.dateLabel}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Total de Títulos: </td><td className="tooltip-content">{content && content.qtdTotalLabel}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Títulos Vendidos: </td><td className="tooltip-content">{content && content.qtdMonthLabel}</td>
                </tr>
            </tbody>
        </table>
    </div>
    )
};

const dataFilled = (data: any) => {
    return data && data.publisherSkuSold && !!data.publisherSkuSold.length
}

export class PublisherSkuSold extends React.Component<IPublisherSkuSoldProps, IPublisherSkuSoldState> {
    constructor(props: IPublisherSkuSoldProps) {
        super(props);
        this.state = {
            customFilter: {
                isChart: true,
            },
        }
    }
    public render() {
        return (
            <Paper className="publisher-sale-block panel-block" >
                <Typography variant="headline" className="panel-title" component="title">
                    Títulos catalogados x Títulos Vendidos
                </Typography>
                {
                    this.props.loading
                    ?
                    <LinearProgress />
                    :
                    (
                        dataFilled(this.props.data)
                        ?
                        (<PublisherSkuSoldDataChart data={this.publisherSkuSoldDataChartMap(this.props.data.publisherSkuSold)} handleClick={this.handleClick} />)
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        )
    }

    private publisherSkuSoldDataChartMap = (data: any) => {

        const mappedData: IPublisherSkuSoldDataChart[] = [];

        data.forEach((e:any) => {

            const item: IPublisherSkuSoldDataChart = {
                
                dateLabel: e.monthName,

                month: e.month,
                
                qtdMonth: Number(e.qtdSold.toString()),
                qtdMonthLabel: NumberLessBRL(e.qtdSold.toString()),

                qtdTotal: Number(e.qtdPublished.toString()),
                qtdTotalLabel: NumberLessBRL(e.qtdPublished.toString())
            };

            mappedData.push(item);
        });
        return mappedData;
    }

    private handleClick = (data:any, index:number) => {
        this.props.changeMonthSkuSoldReference(data.month);
    }
}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/sku-sold/PublisherSkuSold.tsx